import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchCookielessWordpress } from './branches/BranchCookielessWordpress';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchConsiderationProfiles } from './branches/BranchConsiderationProfiles';
import { BranchACQ145 } from './branches/BranchACQ145';
import { BranchCOAC0001 } from './branches/BranchCOAC0001';
import { BranchACQ150 } from './branches/BranchACQ150';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ145, BranchCOAC0001],
  [Flow.Marketing]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ145, BranchCOAC0001],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchConsiderationProfiles, BranchACQ145, BranchCOAC0001],
  [Flow.Service]: [...softwareSignupBranches, BranchConsiderationProfiles, BranchACQ145, BranchCOAC0001],
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches],
  [Flow.Integrations]: [BranchCookielessWordpress],
  [Flow.Purchase]: [BranchACQ150]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};